/**
 * Session utility functions and constants
 */

// Helper to get current date in PST
export const getPSTDate = () => {
  const now = new Date();
  const pstDate = new Date(now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
  return pstDate.toISOString().split('T')[0];
};

// Helper to format date for display in PST
export const formatDatePST = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString + 'T12:00:00');
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'America/Los_Angeles'
  });
};

// Format time for display
export const formatTime = (timeString) => {
  if (!timeString) return '';
  const [hours, minutes] = timeString.split(':');
  const time = new Date();
  time.setHours(parseInt(hours), parseInt(minutes));
  return time.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'America/Los_Angeles'
  });
};

// Grade group display mapping
export const GRADE_GROUPS = {
  elementary: { name: 'Elementary School', grades: '3rd-5th Grade', short: '3-5' },
  middle: { name: 'Middle School', grades: '6th-8th Grade', short: '6-8' },
  high: { name: 'High School', grades: '9th-12th Grade', short: '9-12' }
};

export const getGradeGroupDisplay = (groupId) => {
  return GRADE_GROUPS[groupId]?.grades || groupId;
};

// Default form data for creating a session
export const getDefaultSessionFormData = () => ({
  location_id: '',
  date: '',
  start_time: '',
  end_time: '',
  court: '',
  capacity: 25,
  price: 15.0,
  grade_group: 'elementary',
  published: true
});

// Default form data for bulk session creation
export const getDefaultBulkFormData = () => ({
  location_id: '',
  start_date: '',
  start_time: '',
  end_time: '',
  court: '',
  capacity: 25,
  price: 15.0,
  grade_group: 'elementary',
  recurrence: 'weekly',
  num_sessions: 4,
  published: true
});
